import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'


const BENEFITS = [
    {
        title: 'Reliable and Accurate',
        text: 'Ensure right alignment and connection between your PCB and testing equipment, resulting in accurate and reliable test results.',
        icon: (
            <i class="fa-solid fa-user-shield"></i>
        ),
    },
    {
        title: 'Uniformity and Consistency',
        text: 'With PCB test fixtures we maintain consistency across multiple PCBs with standardized testing procedures and ensuring uniform test conditions.',
        icon: (
           <i class="fa-solid fa-ruler-combined"></i>
        ),
    },
    {
        title: 'Efficient and Time Savvy',
        text: 'PCB test fixtures streamline your testing workflow by automating repetitive tasks, reducing testing time and costs, and improving overall efficiency.',
        icon: (
            <i class="fa-regular fa-clock"></i>
        ),
    },
    {
        title: 'Improve Reliability',
        text: 'Get reliable test results with high accuracy, allowing identification of any error with consistent comparison.',
        icon: (
            <i class="fa-solid fa-gauge-high"></i>
        ),
    },
    {
        title: 'Cost-Effectiveness',
        text: 'Our PCB test fixtures help you save on long-term costs by minimizing manual testing efforts, reducing errors, and improving product quality.',
        icon: (
            <i class="fa-solid fa-chart-line"></i>
        ),
    },
    {
        title: 'Scalability and Flexibility',
        text: 'Adapt to different PCB sizes and configurations with customizable test fixtures, making fixtures scalable for testing different products or versions.',
        icon: (
            <i class="fa-solid fa-sitemap"></i>
        ),
    },
]

const useStyles = makeStyles(() => ({
    section: { padding: '80px 0' },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 26,
        '@media (max-width: 1024px)': { gridTemplateColumns: 'repeat(2, 1fr)' },
        '@media (max-width: 640px)': { gridTemplateColumns: '1fr' },
    },
    card: {
        background: '#fff',
        border: '2px solid #D6D8EC',
        borderRadius: tokens.radiusMd,
        padding: '30px 26px',
        transition: `transform ${tokens.transition}, box-shadow ${tokens.transition}, border-color ${tokens.transition}`,
        '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: tokens.shadowMd,
            borderColor: tokens.colorPrimary,
        },
    },
    icon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 46,
        height: 46,
        color: tokens.colorPrimary,
        marginBottom: 14,
        '& i': {fontSize: '1.8rem', },
    },
    title: { fontFamily:tokens.fontBody , fontSize: '1.4rem', marginBottom: 8, color: '#182AC3;', fontFamily: tokens.fontBody , fontWeight: 'bold'},
    text: { fontSize: '1.2rem', color: tokens.colorTextLight, margin: 0, fontFamily: tokens.fontBody},
}))

export function Benefits() {
    const classes = useStyles()
    return (
        <section className={classes.section}>
            <Container>
                <SectionTitle>Benefits of PCB Test Fixtures</SectionTitle>
                <div className={classes.grid}>
                    {BENEFITS.map((b) => (
                        <div className={classes.card} key={b.title}>
                            <span className={classes.icon} aria-hidden="true">{b.icon}</span>
                            <h3 className={classes.title}>{b.title}</h3>
                            <p className={classes.text}>{b.text}</p>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}
